const isEmpty = (sources: ImageSourceSets) => {
    return (
        !sources ||
        Object.values(sources).every(
            (source) => Object.keys(source as string[]).length === 0,
        )
    );
};

export const handleThumbnail = (article: InboxArticle, focus = "right") => {
    if (article?.listingSize === "small" && !isEmpty(article.thumbnailAlt)) {
        return article;
    }

    const thumbnailEntry = article?.heroImage ?? article?.thumbnail;

    const rawPath = thumbnailEntry?.large?.path;
    let path: string | undefined;
    if (rawPath) {
        const [base, query] = rawPath.split("?");
        const params = new URLSearchParams(query?.replace(/&amp;/g, "&"));
        params.set("w", "320");
        params.set("h", "320");
        params.set("f", focus);
        if (focus === "face") {
            params.set("fit", "fill");
        }
        path = `${base}?${params.toString()}`;
    }

    const thumbnail = {
        title: "",
        width: 320,
        height: 320,
        path,
    };

    return {
        ...article,
        thumbnailAlt: {
            large: thumbnail,
            largeRetina: thumbnail,
            medium: thumbnail,
            mediumRetina: thumbnail,
            small: thumbnail,
            smallRetina: thumbnail,
        },
    };
};
